export const NUMBER_OF_TEAMS_LIMIT = 10
export const MAX_DEPTH_FOR_NESTED_DEPARMENTS_CORE = 2
export const MAX_DEPTH_FOR_NESTED_DEPARMENTS_COMPLETE = 6 // parent team + 5 subdepartments
export const NUMBER_OF_LOCATIONS_LIMIT = 3
export const DEFAULT_WORKING_HOURS_IN_DAY = 8
export const OPEN_API_LIMIT_REQUESTS_PER_MONTH = 30000
export const FREEMIUM_TEAMS_LIMIT = 1
export const FREEMIUM_SUBDEPARTMENTS_LIMIT = 0
export const FREEMIUM_LOCATIONS_LIMIT = 1
export const FREEMIUM_LEAVE_TYPES_LIMIT = 1
export const FREEMIUM_ADDONS_LIMIT = 0
export const FREEMIUM_APPROVERS_LIMIT = 1
export const FREEMIUM_LABELS_LIMIT = 0
export const FREEMIUM_ADMINS_LIMIT = 1
